var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge text-white text-outline-sm",style:({ background: _vm.isCloudy ? 'white' : _vm.zone.color })},[_vm._v(" "+_vm._s(_vm.isCloudy ? '' : _vm.zone.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }